import React from "react";
import { motion } from "framer-motion";

// Frosted dark glass container
export function GlassCard({
    children,
    className = "",
    rounded = "rounded-[28px]",
    elevated = false,
    ...rest
}) {
    return (
        <motion.div
            className={`relative border ${rounded} ${className}`}
            style={{
                background: "rgba(255,255,255,0.03)",
                backdropFilter: "blur(14px)",
                WebkitBackdropFilter: "blur(14px)",
                borderColor: "var(--line)",
                boxShadow: elevated
                    ? "0 30px 80px -20px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.02) inset"
                    : "0 0 0 1px rgba(255,255,255,0.02) inset",
            }}
            {...rest}
        >
            {children}
        </motion.div>
    );
}
